import { QCListItem } from '@dynamika-shared/types/qc';
import { PaginatedResponse } from '@dynamika-shared/types/general';
import { PayloadAction } from '@reduxjs/toolkit';

export enum QC_TASK_STATUSES {
  PENDING = 'PENDING',
  ON_HOLD = 'ON_HOLD',
  IN_PROGRESS = 'IN_PROGRESS',
  QUERY_OPEN = 'QUERY_OPEN',
  DONE = 'DONE',
  FAILED = 'FAILED',
}

export type QCFilters = {
  status: QC_TASK_STATUSES | '';
  assignee: string;
  patientCode: string;
  page: number;
  size: number;
  sort?: string;
};

export type QCTasksListState = {
  loading: boolean;
  error?: Error;
  data: PaginatedResponse<QCListItem> | null;
  filters: QCFilters;
};

export type QCTasksListFetchAction = PayloadAction<{
  clinicalTrialId: string;
  filters: QCFilters;
}>;
export type QCTasksListFetchSuccessAction = PayloadAction<
  PaginatedResponse<QCListItem>
>;

export type QCTasksListSetFiltersAction<
  K extends
    keyof QCTasksListState['filters'] = keyof QCTasksListState['filters'],
> = PayloadAction<{
  filterQuery: K;
  filterValue: QCTasksListState['filters'][K];
}>;
export type QCTasksListClearAction = PayloadAction<boolean | undefined>;
